import React from "react";
import { Link } from "react-router-dom";

export default function AmazingFeatures(){
    const featureData = [
        {
            icon: "mdi mdi-bank",
            title: 'Financial Services',
            desc: 'Analyze contracts, automate compliance checks, and get instant insights from financial reports while keeping sensitive data secure.'
        },
        {
            icon: "mdi mdi-gavel",
            title: 'Legal & Compliance',
            desc: 'Extract key clauses from contracts, analyze legal documents, and ensure compliance with automated document review.'
        },
        {
            icon: "mdi mdi-hospital-building",
            title: 'Healthcare',
            desc: 'Process medical records and research data with complete privacy, ensuring HIPAA compliance while leveraging AI insights.'
        },
        {
            icon: "mdi mdi-shield-lock",
            title: 'Government & Defense',
            desc: 'Handle classified documents and sensitive data with military-grade security while maintaining full control over your information.'
        },
        {
            icon: "mdi mdi-chart-bar",
            title: 'Business Intelligence',
            desc: 'Transform complex data into actionable insights. Ask questions in plain English and get precise answers from your databases.'
        },
        {
            icon: "mdi mdi-school",
            title: 'Research & Education',
            desc: 'Analyze research papers, process student data securely, and maintain academic integrity with local AI processing.'
        },
    ]
    return(
        <>
        <div className="container relative md:mt-24 mt-16">
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Transforming Industries with <br/> <span className="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">Secure AI Solutions</span></h3>

                    <p className="text-slate-400 max-w-xl mx-auto">See how organizations across different sectors are leveraging Privix.AI to transform their operations while maintaining data sovereignty.</p>
                </div>

                <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
                    {featureData.map((item, index) =>{
                        return(
                            <div className="px-6 py-10 shadow hover:shadow-md dark:shadow-gray-800 dark:hover:shadow-gray-700 duration-500 rounded-lg bg-white dark:bg-slate-900 hover:translate-y-[-5px] transition-all group" key={index}>
                                <i className={`${item.icon} text-4xl bg-gradient-to-tl to-amber-400 from-fuchsia-600 text-transparent bg-clip-text group-hover:scale-110 transition-transform duration-300 inline-block`}></i>
        
                                <div className="content mt-7">
                                    <h5 className="text-lg font-semibold hover:text-amber-400 duration-500">{item.title}</h5>
                                    <p className="text-slate-400 mt-3">{item.desc}</p>
                                    
                                    <div className="mt-5">
                                        <Link to="/contact" className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-500 font-medium duration-500">
                                            Learn More <i className="mdi mdi-arrow-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>

                <div className="flex justify-center mt-8">
                    <Link to="/contact" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-amber-400 hover:bg-amber-500 border-amber-400 hover:border-amber-500 text-white rounded-md">
                        Get Started With Your Use Case
                    </Link>
                </div>
            </div>
        </>
    )
}